export class LoadStats {
    constructor() {
        this.aborted = false;
        this.loaded = 0;
        this.retry = 0;
        this.total = 0;
        this.chunkCount = 0;
        this.bwEstimate = 0;
        this.loading = { start: 0, first: 0, end: 0 };
        this.parsing = { start: 0, end: 0 };
        this.buffering = { start: 0, first: 0, end: 0 };
    }
}
